import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-password-requirements',
  templateUrl: './password-requirements.component.html',
  styleUrls: ['./password-requirements.component.less'],
})
export class PasswordRequirementsComponent implements OnInit {
  @Input() showOldPasswordRule: boolean = false;

  constructor() {}

  ngOnInit(): void {}
}
